async function request(endpoint, options = {}) {
  const config = {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };

  const response = await fetch(endpoint, config);

  if (response.status === 401) {
    window.location.href = '/login';
    return;
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || `Request failed with status ${response.status}`);
  }

  if (response.status === 204) return null;
  return response.json();
}

export const ticketService = {
  async getAllTickets(status, search, page = 0, size = 20) {
    const params = new URLSearchParams();
    if (status && status !== 'all') params.append('status', status);
    if (search) params.append('search', search);
    params.append('page', page);
    params.append('size', size);
    return request(`/api/support/tickets/all?${params.toString()}`);
  },

  async getTicketDetail(id) {
    return request(`/api/support/tickets/${id}`);
  },

  async addReply(ticketId, message) {
    return request(`/api/support/tickets/${ticketId}/replies`, {
      method: 'POST',
      body: JSON.stringify({ message }),
    });
  },

  async updateStatus(ticketId, status) {
    return request(`/api/support/tickets/${ticketId}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    });
  },

  async getStats() {
    return request('/api/support/tickets/stats');
  },
};
